import { sortAppointmentsByTimeAsc } from '.';

export default function getMondayAppointmets(appointments) {
    const filterMondayAppointments = appointments.filter(
        item => new Date(item.data.date).getDay() === 1,
    );
    return sortAppointmentsByTimeAsc(filterMondayAppointments);
}
